import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53f7c066"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "name-style-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_5 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_change_input = _resolveComponent("change-input")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "vip-box" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "right",
        "label-width": "150px",
        modelValue: _ctx.loading,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "基本信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                required: true,
                label: "活动名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入活动名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "活动备注" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.remake,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.remake) = $event)),
                    style: {"width":"200px"},
                    placeholder: "请输入活动备注"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "活动商品" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                required: true,
                label: "活动商品"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_link, {
                        onClick: _ctx.operatGoods,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加商品")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ui_table, {
                        data: _ctx.goodsList,
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "title",
                            "min-width": "250"
                          }, {
                            header: _withCtx(() => [
                              _createTextVNode(" 商品名称 ")
                            ]),
                            default: _withCtx(({ row }) => [
                              _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("img", {
                                  src: _ctx.filterValue(_ctx.goodsData[row.goodsId], 'cover')
                                }, null, 8, _hoisted_2),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.filterValue(_ctx.goodsData[row.goodsId], "name")), 1),
                                  _hoisted_3
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "价格(元)",
                            width: "200"
                          }, {
                            default: _withCtx(({ row }) => [
                              (_ctx.filterValue(_ctx.goodsData[row.goodsId], 'minPrice') == _ctx.filterValue(_ctx.goodsData[row.goodsId],
                      'maxPrice'))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.filterValue(_ctx.goodsData[row.goodsId],
                        "maxPrice")), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.filterValue(_ctx.goodsData[row.goodsId], "minPrice") + '~' + _ctx.filterValue(_ctx.goodsData[row.goodsId],
                        "maxPrice")), 1)
                                  ], 64))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "打折",
                            width: "150"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_change_input, {
                                style: {"width":"110px"},
                                goods: _ctx.goodsData[row.goodsId],
                                onChange: ($event: any) => (_ctx.changeInput($event, row, 1)),
                                type: "1",
                                info: row
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode("折")
                                ]),
                                _: 2
                              }, 1032, ["goods", "onChange", "info"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "减价",
                            width: "150"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_change_input, {
                                style: {"width":"110px"},
                                goods: _ctx.goodsData[row.goodsId],
                                onChange: ($event: any) => (_ctx.changeInput($event, row, 2)),
                                type: "2",
                                info: row
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode("元")
                                ]),
                                _: 2
                              }, 1032, ["goods", "onChange", "info"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "指定价格",
                            width: "150"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_change_input, {
                                style: {"width":"110px"},
                                goods: _ctx.goodsData[row.goodsId],
                                onChange: ($event: any) => (_ctx.changeInput($event, row, 3)),
                                type: "3",
                                info: row
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode("元")
                                ]),
                                _: 2
                              }, 1032, ["goods", "onChange", "info"])
                            ]),
                            _: 1
                          }),
                          false
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "最终价",
                                width: "200"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(_ctx.filterValue(_ctx.goodsData[row.goodsId], "showPrice")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_table_column, {
                            align: "right",
                            label: "操作",
                            fixed: "right",
                            width: "150"
                          }, {
                            default: _withCtx(({ row }) => [
                              (row.skuList.length)
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "primary",
                                    onClick: ($event: any) => (_ctx.setSku(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("设置不同折扣")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_link, {
                                type: "primary",
                                style: {"margin":"0 0 0 10px"},
                                onClick: ($event: any) => (_ctx.removeList(row))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}